import { Box } from "@mui/material"
import { Link as RouterLink } from "react-router-dom"

export function BreadcrumbCrumb({ crumb, sx = {} }) {
    const crumbStyle = {
        textOverflow: "ellipsis",
        overflow: "hidden",
        maxWidth: "15vw",
        whiteSpace: "nowrap",
        display: "block",
        ...sx,
    }
    if (crumb.element) {
        return <Box sx={crumbStyle}>{crumb.element}</Box>
    }
    const { label, to, href } = crumb
    const link = to || href
    return (
        <Box sx={crumbStyle}>
            {link ? (
                link.startsWith("http") ? (
                    <a href={link} style={{ color: "inherit", textDecoration: "none" }}>
                        {label}
                    </a>
                ) : (
                    <RouterLink to={link} style={{ color: "inherit", textDecoration: "none" }}>
                        {label}
                    </RouterLink>
                )
            ) : (
                label
            )}
        </Box>
    )
}
